export default __webpack_public_path__ + "a13c6f380a7b41996734dde4ea34da26.png";